const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AppointementList/utils.ts';
import { AppointmentObject } from '@cistec/common_web/defs/notReallyKisim';
import { FormatMessageFn } from '@cistec/common_web/defs/generalDefs';
import moment from 'moment';
import textMap from 'App/components/AppointementList/translations';

export const getDisplayTime = (appointmentObject: AppointmentObject, formatMessage: FormatMessageFn): string => {
    const { startDat, allDayEvent, typ, startDatForPatient } = appointmentObject;
    // Bit of a hack, but helps with not showing time for certain appointment types
    if (typ === 'TRIAGE' || (typ === 'OPERATION' && !startDatForPatient)) return '';

    if (allDayEvent) {
        return formatMessage(textMap.allDay);
    }
    return moment(startDat).format('HH:mm');
};
